import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { wishlistApi } from "../api/wishlistApi";
import toast from "react-hot-toast";
import { getErrorMessage } from "@/lib/api";

export function useWishlist() {
  return useQuery({
    queryKey: ["wishlist"],
    queryFn: wishlistApi.getWishlist,
  });
}

export function useWishlistIds() {
  return useQuery({
    queryKey: ["wishlist-ids"],
    queryFn: wishlistApi.getWishlistIds,
  });
}

export function useAddToWishlist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: wishlistApi.addToWishlist,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["wishlist"] });
      queryClient.invalidateQueries({ queryKey: ["wishlist-ids"] });
      toast.success("Agregado a favoritos");
    },
    onError: (error) => {
      const message = getErrorMessage(error);
      if (message.includes("ya está en tu lista")) {
        toast.error("Este curso ya está en tus favoritos");
      } else if (message.includes("Ya estás inscrito")) {
        toast.error("Ya estás inscrito en este curso");
      } else {
        toast.error(message);
      }
    },
  });
}

export function useRemoveFromWishlist() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: wishlistApi.removeFromWishlist,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["wishlist"] });
      queryClient.invalidateQueries({ queryKey: ["wishlist-ids"] });
      toast.success("Eliminado de favoritos");
    },
    onError: (error) => {
      toast.error(getErrorMessage(error));
    },
  });
}

export function useToggleWishlist() {
  const addMutation = useAddToWishlist();
  const removeMutation = useRemoveFromWishlist();

  return {
    toggle: (courseId: string, isInWishlist: boolean) => {
      if (isInWishlist) {
        removeMutation.mutate(courseId);
      } else {
        addMutation.mutate(courseId);
      }
    },
    isPending: addMutation.isPending || removeMutation.isPending,
  };
}
